import { API_PATHS } from "../../../config/ApiPaths";
import { EDIT_DATA_INFOMATION, GET_DATA_INFOMATION } from "./type";

export const getDataInfoRevenue = (url) => {
  return {
    type: GET_DATA_INFOMATION,
    meta: {
      url,
      method: "GET",
    },
  };
};

export const putDataInfoRevenue = (data) => {
  return {
    type: EDIT_DATA_INFOMATION,
    meta: {
      querry: data,
      url: API_PATHS.editProject,
      method: "PUT",
      showToast: true,
    },
  };
};
